"use strict";
/**
 * Determine the methods and functions to be exported.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Guid = void 0;
var guid_1 = require("./guid");
Object.defineProperty(exports, "Guid", { enumerable: true, get: function () { return guid_1.Guid; } });
//# sourceMappingURL=index.js.map